import Base from './action-base'
import renderFields from './enable-torch.pug'

export default class EnableTorch extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-lightbulb"

  @DEFAULTS:
    seconds: 0

  renderFields: renderFields
